import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { Roles } from 'modules/roles-manager/domain/interfaces/role';

export const useIsAdmin = (forceValue?: boolean): boolean => {
  const { user } = useAuth();
  if (forceValue !== undefined) return forceValue;
  if (!user) return false;
  return !!user.roles.includes(Roles.super_admin);
};
